import styled from 'styled-components/macro';
import { spacing16 } from '../../../styling/design/spacing';

export const DocumentTypeSelectContainer = styled.div<{ visibility: 'visible' | 'hidden' }>`
  display: ${(props) => (props.visibility === 'visible' ? 'block' : 'none')};
  margin-bottom: ${(props) => (props.visibility === 'visible' ? spacing16 : 0)};
`;
